module.exports = __webpack_public_path__ + "img/icon_zhichiguochan.45a0a229.png";